module.exports = __webpack_public_path__ + "static/media/original.cb90c5bd.svg";